// HTML-like Components for Content Editing
// These components provide a simplified, semantic API for non-technical users

// Level 3 - Basic Elements
export { default as Heading } from './elements/Heading'
export { default as Paragraph } from './elements/Paragraph'
export { default as Button } from './elements/Button'
export { default as Link } from './elements/Link'
export { default as Image } from './elements/Image'
export { default as List } from './elements/List'

// Level 2 - Content Blocks
export { default as TextBlock } from './blocks/TextBlock'
export { default as CardBlock } from './blocks/CardBlock'
export { default as ButtonBlock } from './blocks/ButtonBlock'
export { default as ImageBlock } from './blocks/ImageBlock'
export { default as ColumnLayout } from './blocks/ColumnLayout'

// Level 1 - Page Sections
export { default as Hero } from './sections/Hero'
export { default as About } from './sections/About'
export { default as Features } from './sections/Features'
export { default as CallToAction } from './sections/CallToAction'
export { default as Overview } from './sections/Overview'
export { default as Dashboard } from './sections/Dashboard'
export { default as FreeTrial } from './sections/FreeTrial'
export { default as Contact } from './sections/Contact'
